export default "__VITE_ASSET__Btqc2h2G__"